import "jquery/dist/jquery.min.js";
import Endpoints from "@/config/ApiEndpoints.js";
import Axios from "axios";
import { googleMapApiKey } from '@/constants/config';
var moment = require("moment");

export default {
  	//props: ["VehicleId"],
    components: {          
    },
    filters: {            
    },
    data() {
      return {        
        ShowVehiclePositionModel: false,
      	LastVehiclePosition: {},
      	StatusLog: [],
      	ShowStatusLog: false,
      	LastVehiclePositionTrackerCompany: "",
      	center: { 
       		lat: 55.232753,
       		lng: -3.944403
      	},
      	locationMarkers: [],
      	VehicleId: 0,
      	AssetId: 0,
      	vehicleData: {},

      	infoPosition: null,
      	infoOpened: false,
      	infoCurrentKey: null,
      	infoOptions: {
          pixelOffset: {
          	width: 0,
          	height: -35,
          },
          content: "",
      	},

      };
    },   
    mounted() {      
      this.VehicleId = this.$route.params.VehicleId;  
      this.AssetId = this.$route.params.AssetId;        
      //this.ShowVehicleMaps();      
    },
    computed: {    	   		
  	},
    methods: {  
      SetVehicleId(VehicleId){
      	this.AssetId = 0;
      	this.VehicleId = VehicleId;
      },
      SetAssetsId(AssetId){
      	this.VehicleId = 0;
      	this.AssetId = AssetId;
      },
      ShowVehicleMaps(type = ""){ 
      	this.ShowStatusLog=false;      	
      	this.StatusLog=[];      	
      	this.locationMarkers=[];      	
      	this.$swal.fire({
			title: "Fetching data...",	          
			text: "Please wait...",	          
			showConfirmButton: false,
			allowOutsideClick: false,
	    });
        Axios.post(Endpoints.Vehicle.GetInseegoVehiclePosition, {token: localStorage.getItem("token"),vehicle_id: this.VehicleId,AssetId: this.AssetId,}).then((Response) => {          
          if (Response?.data?.success) {
          	this.lastUpdatedPosition =  Response.data.lastUpdateTime
          	this.LastVehiclePosition = Response.data.LastVehiclePosition;
          	this.vehicleData = Response.data.vehicleData;
          	if(Response.data.StatusLog){
          		this.StatusLog = Response.data.StatusLog;
          	}
          	if(this.StatusLog.length>0){
          		this.ShowStatusLog = true
          	}
          	//we can also fetch the location lat/long by following api
          	//Axios.get('https://maps.googleapis.com/maps/api/geocode/json?address='+this.LastVehiclePosition.Location+'&key='+googleMapApiKey).then((Response) => {})      		
          	if(this.LastVehiclePosition?.Location){ 
                const lat = parseFloat(this.LastVehiclePosition.Latitude);
                const lng = parseFloat(this.LastVehiclePosition.Longitude);
                if (Number.isFinite(lat) && Number.isFinite(lng)) {
          		    const marker = { lat: lat, lng: lng };
          		    var driver='';
                	if(this.vehicleData?.driver?.driver?.forename){                	                	
                		//title =element?.driver?.driver?.forename+' '+element?.driver?.driver?.surname;
                		driver =this.vehicleData?.driver?.driver?.forename+' '+this.vehicleData?.driver?.driver?.surname;
                	}
          		    this.locationMarkers.push({ 
          		    	position: marker,
          		    	title: this.AssetId>0?this.vehicleData.name:this.vehicleData.vrm,
                  		titleMain: this.AssetId>0?this.vehicleData.name:this.vehicleData.vrm,
                  		driver: driver,
                  		status: this.LastVehiclePosition?.StatusText,
                  		location: this.LastVehiclePosition?.Location,
                  		label: { text: this.AssetId>0?this.vehicleData.name:this.vehicleData.vrm, className: "map-label" }, 
          		    });
          		    this.center = marker;
          		    this.ShowVehiclePositionModel = true;
                } else {
                  return;
                }                
        		this.LastVehiclePositionTrackerCompany = Response.data.TrackerCompany;
        		this.$swal.close();
        		/*Axios.get('https://maps.googleapis.com/maps/api/geocode/json?latlng='+this.LastVehiclePosition.Latitude+','+this.LastVehiclePosition.Longitude+'&key='+googleMapApiKey).then((Response) => {        			
        			if(Response.data && Response.data.results && Response.data.results[0]){
        				this.LastVehiclePosition.Location = Response.data.results[0]['formatted_address']
        				this.locationMarkers[this.locationMarkers.length-1]['location'] = this.LastVehiclePosition.Location
        			}
        		})*/      		         		          	
	      	}else{
	      		this.$swal.fire({
					title: "Oops!",
					text: 'Error in Getting Vehicle Location',
					icon: "error",
					confirmButtonText: "Close",
            	});
	      	}
            
          }else{          	
          	this.$swal.fire({
              title: "Oops!",
              text: Response?.data?.message || "Something went wrong",
              icon: "error",
              confirmButtonText: "Close",
            });
          }
        });
      },

      togglePositionInfo: function (marker, idx) {       	  	
	    this.infoPosition = marker.position;      
	    this.infoOptions.content =
	        '<div id="mapcontent" style="text-align:left"><h1 id="firstHeading" class="firstHeading" style="margin: 0px;">' +
	        marker.titleMain +
	        '</h1>';
	        if(marker.driver){
	        	this.infoOptions.content +='<h4 style="margin: 5px 0px;">Driver: '+marker.driver +'</h4>';
	        }
	        if(marker.status){
	        	this.infoOptions.content +='<h4 style="margin: 5px 0px;">Status: '+marker.status +'</h4>';
	        }       

		    if(marker.location==""){
	      	Axios.get('https://maps.googleapis.com/maps/api/geocode/json?latlng='+marker.position.lat+','+marker.position.lng+'&key='+googleMapApiKey).then((Response) => {        			
	        			if(Response.data && Response.data.results && Response.data.results[0]){        				
	        				this.infoOptions.content +='<div id="bodyContent"><p>' + Response.data.results[0]['formatted_address'] +"</p></div></div>";
	        			}
	        		}) 
	      	}else{
	      		this.infoOptions.content +='<div id="bodyContent"><p>' + marker.location +"</p></div></div>";
	      	}

	      //check if its the same marker that was selected if yes toggle
	    if (this.infoCurrentKey == idx) {
	        this.infoOpened = !this.infoOpened;
	    } else {
	        this.infoOpened = true;
	        this.infoCurrentKey = idx;
	    }
      },      
    },
  };
